export const RECEIVE_PLACE_SEND = 'RECEIVE_PLACE_SEND';
